import moment from 'moment';

class Calendar {
  _localDate = moment().clone();
  _thisDate = moment().clone().format('YYYY-MM-DD');
  _inner;
  _buttons;

  constructor(options) {
    this.element = options.element;
    this._inner = this.element.querySelector('.swiper-wrapper', 'slider__wrapper');

    this.#init()
  }

  #init() {
    if (this._inner.querySelector('.swiper-slide')) {
      this._inner.querySelectorAll('.swiper-slide').forEach(item => {
        item.remove()
      })
    }

    let count = 12;
    for (let i = 0; i < (count + 1); i++) {
      this._localDate = this.#newMonth(this._localDate, i, count);
    }

    if (window.calendar.slider) {
      window.calendar.slider.update()
    }

    this._buttons = this.element.querySelectorAll('.jsFilterDate');
    this.#buttons();
  }

  #newMonth(localDate, index, last) {
    const tempDate = localDate.clone();
    let monthStart = index == 0 ? localDate.clone() : tempDate.clone().startOf('month');
    let monthEnd = index == last ? tempDate.clone().subtract(1, 'day') : tempDate.clone().endOf('month');
    let monthName = tempDate.format('MMMM');
    let day = monthStart.clone();
    let monthInner;

    // Создание
    let slide = document.createElement('div');
    let month = document.createElement('div');
    let days = document.createElement('div');
    slide.classList.add('swiper-slide', 'slider__slide');
    month.classList.add('calendar__month');
    days.classList.add('calendar__days');
    month.innerHTML = `<span>` + monthName + `</span>`;
    month.append(days)

    this._inner.append(slide)
    slide.append(month)

    monthInner = days;

    // Наполнение
    while (!day.isAfter(monthEnd)) {
      let dayDate = day.clone();
      let element = this.#createDay(dayDate)
      monthInner.append(element)

      day.add(1, 'day');
    }


    return tempDate.clone().add(1, 'month');
  }

  #createDay(date) {

    let name = date.format('dd');
    let number = date.format('DD');
    let value = date.format('YYYY-MM-DD');
    let dayPattern = `
            <strong>` + number + `</strong>
            <span>` + name + `</span>
        `;

    let element = document.createElement('div');
    element.classList.add('calendar__day', 'jsFilterDate');
    element.setAttribute('data-calendar-date', value);

    if (name == 'сб' || name == 'вс') {
      element.classList.add('calendar__day--weekend')
    }

    element.innerHTML = dayPattern;

    return element;
  }

  #buttons() {
    let that = this;
    this._buttons.forEach(item => {
      item.addEventListener('click', function (e) {
        let all = that._buttons;

        if (that.element.querySelectorAll('.jsFilterDate.is-active').length >= 2) {
          all.forEach(element => {
            element.classList.remove('is-range')
            element.classList.remove('is-active')
          })
        }

        item.classList.add('is-active')

        run()

        function run() {
          let allChecked = that.element.querySelectorAll('.jsFilterDate.is-active'),
            array = [],
            minTemp,
            maxTemp,
            minItem,
            maxItem,
            minIndex,
            maxIndex,
            min = '',
            max = '';

          findMinMax()
          findIndex()
          callback()

          function findMinMax() {
            allChecked.forEach(item => {
              let value = Date.parse(item.getAttribute('data-calendar-date'));
              array.push(value);
            })

            minTemp = Math.min.apply(null, array);
            maxTemp = Math.max.apply(null, array);

            allChecked.forEach(item => {
              let value = item.getAttribute('data-calendar-date');

              // minTemp == Date.parse(value) ? (min = value, minItem = item) : maxTemp == Date.parse(value) ? (max = value, maxItem = item): '';

              if (minTemp == Date.parse(value)) {
                min = value;
                minItem = item;

              } else if (maxTemp == Date.parse(value)) {
                max = value;
                maxItem = item;
              }
            })
          }

          function findIndex() {
            all.forEach((item, index) => {
              if (item == minItem) {
                minIndex = index;
              } else if (item == maxItem) {
                maxIndex = index;
              }
            })

            if (maxIndex != undefined) {
              let tempAll = Array.prototype.slice.call(all, minIndex, maxIndex)

              tempAll.forEach(item => {
                item.classList.add('is-range');
              })
            }
          }

          function callback() {
            let filterWrapper = item.closest('.filter');

            if (filterWrapper) {
              filterWrapper.querySelector('input[name="date_from"').value = min
              filterWrapper.querySelector('input[name="date_to"').value = max
            }

            if (min != '' && max != '') {
              window.datepickerChange(filterWrapper.querySelector('input[name="date_from"'))
            }
          }
        }
      })
    });
  }
}

window.Calendar = Calendar;

export default Calendar;
